import { SVGProps } from './types';

const PdfFileTypeIcon = (props: SVGProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
      {...props}
    >
      <path
        fill="#F04438"
        d="M13.9999 3.18288V14.4C13.9999 15.2837 13.2836 16 12.3999 16H3.6C2.71634 16 2 15.2837 2 14.4V1.6C2 0.716345 2.71634 0 3.6 0H10.5347L13.9999 3.18288Z"
      />
      <path
        fill="#FECDCA"
        d="M13.9999 3.18288H10.9347C10.7138 3.18288 10.5347 3.00379 10.5347 2.78288V0L13.9999 3.18288Z"
      />
      <path
        fill="#fff"
        d="M6.73377 10.8864C6.73377 11.0328 6.70017 11.1672 6.63297 11.2896C6.56577 11.4096 6.46257 11.5068 6.32337 11.5812C6.18417 11.6556 6.01137 11.6928 5.80497 11.6928H5.42337V12.6H4.80777V10.0728H5.80497C6.00657 10.0728 6.17697 10.1076 6.31617 10.1772C6.45537 10.2468 6.55977 10.3428 6.62937 10.4652C6.69897 10.5876 6.73377 10.728 6.73377 10.8864ZM5.75817 11.2032C5.87577 11.2032 5.96337 11.1756 6.02097 11.1204C6.07857 11.0652 6.10737 10.9872 6.10737 10.8864C6.10737 10.7856 6.07857 10.7076 6.02097 10.6524C5.96337 10.5972 5.87577 10.5696 5.75817 10.5696H5.42337V11.2032H5.75817ZM8.00105 10.0728C8.26745 10.0728 8.50025 10.1256 8.69945 10.2312C8.89865 10.3368 9.05225 10.4856 9.16025 10.6776C9.27065 10.8672 9.32585 11.0868 9.32585 11.3364C9.32585 11.5836 9.27065 11.8032 9.16025 11.9952C9.05225 12.1872 8.89745 12.336 8.69585 12.4416C8.49665 12.5472 8.26505 12.6 8.00105 12.6H7.05425V10.0728H8.00105ZM7.96145 12.0672C8.19425 12.0672 8.37545 12.0036 8.50505 11.8764C8.63465 11.7492 8.69945 11.5692 8.69945 11.3364C8.69945 11.1036 8.63465 10.9224 8.50505 10.7928C8.37545 10.6632 8.19425 10.5984 7.96145 10.5984H7.66985V12.0672H7.96145ZM11.3151 10.0728V10.566H10.2855V11.0988H11.0559V11.5776H10.2855V12.6H9.66988V10.0728H11.3151Z"
      />
    </svg>
  );
};

export { PdfFileTypeIcon };
